import script from "./WhitelistPhoneComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WhitelistPhoneComponent.vue?vue&type=script&setup=true&lang=js"

import "./WhitelistPhoneComponent.vue?vue&type=style&index=0&id=69ae2e6d&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69ae2e6d"]])

export default __exports__